/**
 * TodaySalesPage.jsx
 *
 * Cartes mises en vente aujourd'hui
 * ✅ Affiche le nombre de cartes
 */

import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin, Tag, Space } from "antd";
import { searchCards } from "../api/api";
import CardGrid from "../components/Cards/CardGrid";
import SortBar from "../components/Search/SortBar";
import AdvancedSearchFilters from "../components/Search/AdvancedSearchFilter";

/**
 * TodaySalesPage - Cartes mise en vente aujourd'hui
 */
export default function TodaySalesPage() {
    const [cards, setCards] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [sortBy, setSortBy] = useState("date");
    const [order, setOrder] = useState("desc");
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({
        start_sell_today: true, // Toujours true pour cette page
    });

    const fetchCards = async (pageNum = 1, reset = false) => {
        try {
            setLoading(true);
            const res = await searchCards(filters, pageNum, 20, sortBy, order);
            const data = res.data.cards || [];

            setCards(reset || pageNum === 1 ? data : (prev) => [...prev, ...data]);
            setTotal(res.data.total || 0);
            setHasMore(data.length >= 20);
        } catch (err) {
            console.error("Erreur", err);
        } finally {
            setLoading(false);
        }
    };

    // Initial load + tri
    useEffect(() => {
        setPage(1);
        fetchCards(1, true);
    }, [sortBy, order, filters]);

    const fetchMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchCards(nextPage);
    };

    const handleApplyFilters = (appliedFilters) => {
        const newFilters = {
            ...appliedFilters,
            start_sell_today: true, // Force toujours true
        };
        setFilters(newFilters);
        setPage(1);
        setHasMore(true);
    };

    return (
        <div style={{ padding: "16px", minHeight: "100vh" }}>
            <h2 style={{ marginBottom: "8px", fontSize: "24px", fontWeight: "600" }}>
                Cartes mises en vente aujourd'hui
            </h2>

            {/* ✅ Affiche le nombre de cartes */}
            <Space style={{ marginBottom: "16px" }}>
                <Tag color="green">{total} carte{total > 1 ? "s" : ""}</Tag>
                <span style={{ opacity: 0.6, fontSize: "14px" }}>
                    Affichées : {cards.length}
                </span>
            </Space>

            <AdvancedSearchFilters
                initialFilters={filters}
                onApply={handleApplyFilters}
            />

            <SortBar sortBy={sortBy} setSortBy={setSortBy} order={order} setOrder={setOrder} />

            {loading && cards.length === 0 ? (
                <div style={{ textAlign: "center", padding: "48px" }}>
                    <Spin />
                </div>
            ) : (
                <InfiniteScroll
                    dataLength={cards.length}
                    next={fetchMore}
                    hasMore={hasMore}
                    loader={
                        <h4 style={{ textAlign: "center", padding: "16px" }}>
                            Chargement...
                        </h4>
                    }
                >
                    <CardGrid cards={cards} />
                </InfiniteScroll>
            )}
        </div>
    );
}